import { LegalLayout } from '../../../components/layout/LegalLayout';

export default function AccessibilitePage() {
  return (
    <LegalLayout
      title="Déclaration d'accessibilité"
      url="https://solutionecofrance.fr/legal/accessibilite"
      lastUpdated="01/05/2026"
    >
      <p>
        Solution Éco France s’engage à rendre son site internet accessible à toutes et tous,
        conformément à <strong>l’article 47 de la loi n° 2005-102 du 11 février 2005</strong>{' '}
        pour l’égalité des droits et des chances, à <strong>l’article L. 412-2-2 du Code de la
        consommation</strong> et au <strong>Référentiel Général d’Amélioration de
        l’Accessibilité (RGAA), version 4.1</strong>.
      </p>
      <p>
        La présente déclaration d’accessibilité s’applique au site{' '}
        <strong>solutionecofrance.fr</strong> et à ses sous-domaines de production.
      </p>

      <h2>1. État de conformité</h2>
      <p>
        Le site <strong>solutionecofrance.fr</strong> est <strong>partiellement conforme</strong>{' '}
        au référentiel <em>WCAG 2.2 niveau AA</em> et au RGAA 4.1, en raison des non-conformités
        et dérogations identifiées ci-dessous.
      </p>

      <h2>2. Résultats des tests</h2>
      <p>
        L’audit interne d’accessibilité a été réalisé en mai 2026 par l’équipe technique de
        Solution Éco France, à l’aide des outils suivants :
      </p>
      <ul>
        <li>
          <strong>axe DevTools</strong> (Deque) — analyse automatisée par page ;
        </li>
        <li>
          <strong>Lighthouse</strong> (Google) — analyse synthétique ;
        </li>
        <li>
          <strong>Tests manuels au clavier</strong> (focus, tabulation, raccourcis) ;
        </li>
        <li>
          <strong>Tests avec lecteurs d’écran</strong> NVDA (Windows) et VoiceOver (macOS / iOS) ;
        </li>
        <li>
          <strong>Tests avec zoom 200 %</strong> et navigation tactile.
        </li>
      </ul>
      <p>
        À l’issue de cet audit interne, <em>[X] % des critères RGAA 4.1 ont été respectés</em>.
        Un audit externe complet par un cabinet certifié est planifié au troisième trimestre
        2026 ; ses résultats seront publiés sur la présente page.
      </p>

      <h2>3. Contenus non accessibles</h2>

      <h3>3.1. Non-conformités</h3>
      <ul>
        <li>
          Certaines images de cas clients héritées de l’ancienne version du site peuvent ne
          pas disposer d’une alternative textuelle satisfaisante (RGAA 1.1).
        </li>
        <li>
          Certains composants tiers embarqués (cartes interactives, iframes) peuvent présenter
          des écarts de contraste ou des libellés non explicites (RGAA 3.2, 11.1).
        </li>
        <li>
          Quelques tableaux de données complexes (comparateur d’offres) ne disposent pas
          encore de résumé ni d’en-têtes structurés conformes (RGAA 5.4 à 5.7) — correction
          en cours.
        </li>
      </ul>

      <h3>3.2. Dérogations pour charge disproportionnée</h3>
      <p>Aucune dérogation pour charge disproportionnée n’est revendiquée à ce jour.</p>

      <h3>3.3. Contenus non soumis à l’obligation d’accessibilité</h3>
      <ul>
        <li>
          Documents PDF antérieurs au 23 septembre 2018, conservés à titre d’archives.
        </li>
        <li>
          Contenus de tiers ni financés ni développés par Solution Éco France et qui ne sont pas
          sous notre contrôle (par exemple, vidéos hébergées par un fournisseur tiers).
        </li>
      </ul>

      <h2>4. Établissement de la déclaration</h2>
      <ul>
        <li>
          <strong>Date d’établissement :</strong> 01 mai 2026.
        </li>
        <li>
          <strong>Date de dernière mise à jour :</strong> 01 mai 2026.
        </li>
        <li>
          <strong>Technologies utilisées :</strong> HTML 5, CSS 3 (Tailwind CSS v3.4), JavaScript
          (React 18 + Vike SSR), SVG.
        </li>
        <li>
          <strong>Environnements de test :</strong> Chrome (Windows 11, macOS 14), Firefox
          (Windows 11), Safari (macOS 14, iOS 17), Edge (Windows 11), avec NVDA et VoiceOver.
        </li>
      </ul>

      <h2>5. Voies de recours</h2>
      <p>
        Si vous constatez un défaut d’accessibilité vous empêchant d’accéder à un contenu ou
        à une fonctionnalité du site, vous pouvez nous contacter, et si vous n’obtenez pas de
        réponse rapide de notre part, vous êtes en droit d’exercer un recours :
      </p>
      <ul>
        <li>
          <strong>Contacter Solution Éco France :</strong>{' '}
          <a href="mailto:accessibilite@solutionecofrance.fr">
            accessibilite@solutionecofrance.fr
          </a>{' '}
          — réponse circonstanciée sous 10 jours ouvrés.
        </li>
        <li>
          <strong>Saisir le Défenseur des droits</strong> — formulaire en ligne :{' '}
          <a
            href="https://formulaire.defenseurdesdroits.fr"
            rel="noopener noreferrer"
            target="_blank"
          >
            formulaire.defenseurdesdroits.fr
          </a>
          ; ou par courrier (gratuit, sans affranchissement) : Défenseur des droits, Libre
          réponse 71120, 75342 Paris CEDEX 07.
        </li>
        <li>
          <strong>Contacter un délégué du Défenseur des droits près de chez vous</strong> —{' '}
          <a
            href="https://www.defenseurdesdroits.fr/saisir/delegues"
            rel="noopener noreferrer"
            target="_blank"
          >
            defenseurdesdroits.fr/saisir/delegues
          </a>
          .
        </li>
      </ul>

      <h2>6. Plan d’amélioration</h2>
      <ul>
        <li>
          <strong>T2 2026 :</strong> finalisation des alternatives textuelles sur l’ensemble des
          médias hérités, refonte des tableaux complexes, audit interne de tous les composants
          critiques.
        </li>
        <li>
          <strong>T3 2026 :</strong> audit externe complet RGAA 4.1 par un cabinet
          d’accessibilité référencé, publication du rapport.
        </li>
        <li>
          <strong>T4 2026 :</strong> correction des non-conformités identifiées par l’audit
          externe, mise à jour de la présente déclaration.
        </li>
        <li>
          <strong>2027 :</strong> mise en place d’une revue d’accessibilité systématique pour
          chaque nouvelle fonctionnalité (intégration au pipeline CI/CD : axe-core,
          Lighthouse CI, tests Playwright a11y).
        </li>
      </ul>

      <h2>7. Engagement de progrès continu</h2>
      <p>
        L’accessibilité numérique fait partie intégrante de notre démarche qualité. Chaque
        membre de l’équipe produit / design / développement est sensibilisé aux exigences du
        RGAA 4.1 et formé à leur mise en œuvre opérationnelle. Une re-évaluation annuelle
        permet d’ajuster nos priorités et de garantir une amélioration continue.
      </p>
    </LegalLayout>
  );
}
